/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, type HttpValidationProblemDetails, type IError } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /directories/{directory-id}/restore
 */
export interface RestoreRequestBuilder extends BaseRequestBuilder<RestoreRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     post(requestConfiguration?: RequestConfiguration<RestoreRequestBuilderPostQueryParameters> | undefined) : Promise<void>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<RestoreRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
export interface RestoreRequestBuilderPostQueryParameters {
    recursive?: boolean;
}
/**
 * Uri template for the request builder.
 */
export const RestoreRequestBuilderUriTemplate = "{+baseurl}/directories/{directory%2Did}/restore{?recursive*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const RestoreRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: RestoreRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, application/problem+json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
};
/* tslint:enable */
/* eslint-enable */
